module.exports = __webpack_public_path__ + "media/images/checkStatus-Incomplete-a9590350.png";